export default __webpack_public_path__ + "static/media/register_logo.6ec0ad50.svg";